export default "__VITE_ASSET__CMeS5Mpm__"